import { useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { LoadingSpinner } from '@/shared/components';
import { cn } from '@/utils/tailwind.util';
import { quizDataToAnswerPageBlock, quizDataToQuestionPageBlock } from './util/quizDataToBlock';
import { useLoadingWorksheetPreviewContext, usePaginationContext, useWorksheetSettingContext } from './context';
import { AnswerPageBlockRenderer, QuestionPageBlockRenderer } from './QuizWorksheetBlocks';
import { QuizWorksheetAnswerPages, QuizWorksheetQuestionPages } from './QuizWorksheetPage';
export const QuizWorksheetPDFView = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    worksheetTitle,
    worksheetTeacherName,
    category,
    quizList,
    entryMapHashId,
    enterCode,
    additionalSetting,
    shouldIncludeAnswerPage
  } = useWorksheetSettingContext();
  const {
    isLoading
  } = useLoadingWorksheetPreviewContext();
  const {
    handleQuestionPageRenderComplete,
    handleAnswerPageRenderComplete,
    questionPageCount,
    handleAnswerPageIncludeChange
  } = usePaginationContext();
  useEffect(() => {
    handleAnswerPageIncludeChange(shouldIncludeAnswerPage);
  }, [handleAnswerPageIncludeChange, shouldIncludeAnswerPage]);
  return <div className={cn('flex flex-col gap-y-sm relative max-mobile-lg:h-[250px] max-mobile-lg:shrink-0 max-h-[648px] overflow-y-scroll  bg-neutral max-w-[700px] px-2xl py-2xl', 'border-r max-mobile-lg:border-b border-assistive', isLoading && 'overflow-hidden')} data-sentry-component="QuizWorksheetPDFView" data-sentry-source-file="QuizWorksheetPDF.tsx">
      {isLoading && <div className="absolute inset-0 z-30 flex items-center justify-center bg-white">
          <LoadingSpinner className="size-lg text-primary" />
        </div>}

      <QuizWorksheetQuestionPages blocks={quizDataToQuestionPageBlock(quizList)} itemRenderer={QuestionPageBlockRenderer} onPageRenderComplete={handleQuestionPageRenderComplete} header={{
      title: worksheetTitle,
      teacherName: worksheetTeacherName,
      subTitle: t('quizWorksheet.category', {
        category
      })
    }} footer={{
      enterCode: additionalSetting.addJoinCode ? enterCode : undefined,
      entryMapHashId
    }} data-sentry-element="QuizWorksheetQuestionPages" data-sentry-source-file="QuizWorksheetPDF.tsx" />
      {shouldIncludeAnswerPage && <QuizWorksheetAnswerPages blocks={quizDataToAnswerPageBlock(quizList)} itemRenderer={AnswerPageBlockRenderer} onPageRenderComplete={handleAnswerPageRenderComplete} header={{
      title: worksheetTitle,
      teacherName: worksheetTeacherName,
      subTitle: t('quizWorksheet.answerSheet')
    }} footer={{
      enterCode: additionalSetting.addJoinCode ? enterCode : undefined,
      entryMapHashId,
      startPageNumber: questionPageCount + 1
    }} />}
    </div>;
};